// Редюсер для управления договорами и комиссиями
import * as constants from './constants';

// list/item для договоров целиком переехали на MobX (contractStore).
// Здесь остаётся только error (используется чужими комиссионными reducer-cases
// и читается, например, из PartnerRegionsPanel) и состояния по комиссиям.
export const initialPartnerContractState = {
  error: undefined,

  partnerContractFee: {}, // объект по 1-ой комиссии
  partnerContractFeesId: undefined, // id объекта комиссии, который будет загружен в partnerContractFee
  loadingPartnerContractFee: false, // признак, что идёт чтение partnerContractFee

  contractFees: [], // комиссии по договорам
  partnerContractId: undefined, // id договора. данные по которому находятся в contractFees
  loadingContractFees: false, // признак, что идёт чтение contractFees

  servicePartnerFiasFees: [], // комиссии по связке сервис-партнёр-регион (с обязательной привязкой к договору)
  servicePartnerId: undefined, // id связки, данные по которому находятся в servicePartnerFiasFees
  loadingServicePartnerFiasFees: false, // признак, что идёт чтение servicePartnerFiasFees

  serviceOfficeFees: [], // комиссии по связке сервис-офис  (с обязательной привязкой к договору)
  serviceOfficeId: undefined, // id связки, данные по которому находятся в serviceOfficeFees
  loadingServiceOfficeFees: false, // признак, что идёт чтение serviceOfficeFees

  partnerFees: [], // комиссии по партнёру
  partnerId: undefined, // partnerId, данные по которому находятся в partnerFees
  loadingServicePartnerFees: false, // признак, что идёт чтение servicePartnerFiasFees
};

export const partnerFeesReducer = (state = initialPartnerContractState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.CREATE_CONTRACT_SERVICE_SUCCESS:
    case constants.CREATE_CONTRACT_SERVICE_FAIL:
    case constants.UPDATE_CONTRACT_SERVICE_SUCCESS:
    case constants.UPDATE_CONTRACT_SERVICE_FAIL:
    case constants.DELETE_CONTRACT_SERVICE_SUCCESS:
    case constants.DELETE_CONTRACT_SERVICE_FAIL:
    case constants.FETCH_PARTNER_FEE:
    case constants.FETCH_PARTNER_FEE_SUCCESS:
    case constants.FETCH_PARTNER_FEE_FAIL:
    case constants.FETCH_PARTNER_FEES_BY_CONTRACT_ID:
    case constants.FETCH_PARTNER_FEES_BY_CONTRACT_ID_SUCCESS:
    case constants.FETCH_PARTNER_FEES_BY_CONTRACT_ID_FAIL:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_SUCCESS:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_PARTNER_ID_FAIL:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_SUCCESS:
    case constants.FETCH_PARTNER_FEES_BY_SERVICE_OFFICE_ID_FAIL:
    case constants.FETCH_PARTNER_FEES_BY_PARTNER_ID:
    case constants.FETCH_PARTNER_FEES_BY_PARTNER_ID_SUCCESS:
    case constants.FETCH_PARTNER_FEES_BY_PARTNER_ID_FAIL:
    case constants.CLEAR_PARTNER_FEES_BY_PARTNER_ID:
    case constants.CREATE_CONTRACT_LEGAL_FEE_SUCCESS:
    case constants.CREATE_CONTRACT_LEGAL_FEE_FAIL:
    case constants.UPDATE_CONTRACT_LEGAL_FEE_SUCCESS:
    case constants.UPDATE_CONTRACT_LEGAL_FEE_FAIL:
    case constants.DELETE_CONTRACT_LEGAL_FEE_SUCCESS:
    case constants.DELETE_CONTRACT_LEGAL_FEE_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default partnerFeesReducer;
